import { createSlice } from "@reduxjs/toolkit";
import HatalikVerileriResponse from "src/models/GenelTanimlar/HastalikVerileriResponse";
import VwHbsHastaliktanimDTO from "src/models/HastalikTanim/VwHbsHastaliktanimDTO";
import VwHbsHastaliktanimislemDTO from "src/models/HastalikTanim/VwHbsHastaliktanimislemDTO";
import VwHbsHataliktanimtaniDTO from "src/models/HastalikTanim/VwHbsHataliktanimtaniDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { HastalikTanimApi } from "src/services/HastalikTanim/HastalikTanimApi";

interface IHastalikTanim {
    hastalikTanimActiveRow: VwHbsHastaliktanimDTO;
    hastalikTanimtaniAcitveRow: VwHbsHataliktanimtaniDTO;
    taniIslemList: Array<VwHbsHastaliktanimislemDTO>;

    dialogParam: number;
    fetchParam: number;
    hastalikVerileri: HatalikVerileriResponse
}

const HastalikTanimSlice = createSlice <IHastalikTanim, MapReducerPayloads<IHastalikTanim, {
    setHastalikTanimActiveRow: VwHbsHastaliktanimDTO,
    setHastalikTanimtaniAcitveRow: VwHbsHataliktanimtaniDTO,
    setDialogParam: number,
    setFetchParam: number,
    setTaniIslemList: Array<VwHbsHastaliktanimislemDTO>
    sethastalikVerileri: HatalikVerileriResponse
}>>({
        name: 'yatakTanim',
        initialState: {
            hastalikTanimActiveRow: new VwHbsHastaliktanimDTO(),
            hastalikTanimtaniAcitveRow: new VwHbsHataliktanimtaniDTO(),
            dialogParam: 0,
            fetchParam: 0,
            taniIslemList: [],
            hastalikVerileri: new HatalikVerileriResponse()
        },
        reducers: {
            setHastalikTanimActiveRow:(state, action) => {
                state.hastalikTanimActiveRow = action.payload
            },
            setHastalikTanimtaniAcitveRow:(state, action) => {
                state.hastalikTanimtaniAcitveRow = action.payload
            },
            setDialogParam: (state, action) => {
                state.dialogParam = action.payload
            },
            setFetchParam: (state, action) => {
                state.fetchParam = action.payload
            },
            setTaniIslemList: (state, action) => {
                state.taniIslemList = action.payload
            },
            sethastalikVerileri: (state, action) => {
                state.hastalikVerileri = action.payload
            }
        },
            extraReducers: (builder) => {
        builder.addMatcher(HastalikTanimApi.endpoints.MuracaataBagliHastalikIslemGetir.matchFulfilled, (state, action) => {
            state.hastalikVerileri = action.payload;
          });
    }
    })
export default HastalikTanimSlice;